import wildcard from 'wildcard';
import store from '@/store';

/**
 * 헤더 타입 경로 설정
 * [type: string, includes: string[], excludes: string[]]
 */
const HEADER_TYPE_PAGES = [
	['A', ['/', '/home', '/home/*']],
	['C', ['/login', '/promotion/bizMeka/account']],
	[
		'None',
		[
			'/joinfinish',
			'/checkguide',
			'/notFound',
			'/memberInfowithdrawalend',
			'/survey/respond',
			'/promotion/landing',
			'/pick/*',
			'/pickFinish',
		],
	],
	['D', ['/search']],
	['E', ['/orderSend/cartSend']],
	[
		'F',
		[
			'/join',
			'/join/*',
			'/findid',
			'/findidok',
			'/findpwd',
			'/findpwdset',
			'/changepwd',
			'/order/gorderInfo',
			'/order/gorderBuy',
			'/order/gorderFinish',
			'/mybiz/memberinfomng',
			'/mybiz/memberwdrw',
			'/pickDetail/*',
		],
	],
	['B', ['/**/*']],
];

/**
 * 푸터 타입 경로 설정
 * [type: string, includes: string[], excludes: string[]]
 */
const FOOTER_TYPE_PAGES = [
	['A', ['/', '/home', '/home/*']],
	['B', ['/promotion/bizMeka/account']],
];

/**
 * 퀵메뉴 사용 경로 설정
 * [includes: string[]]
 */
const QUICK_MENU_ENABLED_PAGES = [
	'/',
	'/home',
	'/home/*',
	'/search',
	'/search/*',
	'/orderSend/apiintro',
	'/orderSend/tempSend',
	'/bizshop',
	'/notice',
	'/serviceguidelist',
	'/serviceguideview',
	'/faq',
	'/faqview',
	'/qna',
	'/qnaview',
	'/qnawrite',
	'/eventlist',
	'/eventfinish',
	'/eventview',
	'/eventreport',
	'/eventann',
	'/specialprice',
	'/mybiz/bizmain',
	'/mybiz/prchmng',
	'/mybiz/prchmng/*',
	'/mybiz/bizmnmng',
	'/company/terms',
	'/mybiz/memberinfologin',
	'/mybiz/fwnbmng',
	'/mybiz/submemberlist',
	'/mybiz/submemberdetail',
	'/mybiz/submembergorder',
	'/mybiz/txtmsgbanner/image',
	'/mybiz/txtmsgbanner/message',
	'/mybiz/sendingprofile',
	'/mybiz/managetemplate',
	'/mybiz/contactmng',
	'/survey/statistics',
	'/survey/statistics/detail',
	'/estimate/manage',
	'/giftishow',
	'/survey/serviceinfo',
	'/msgsvc/serviceInfo',
	'/msgsvc/sendMng',
	'/msgsvc/sendDetail',
	'/msgsvc/subSendDetail',
	'/msgsvc/sendReLogin',
	'/bizguide',
	'/allianceZone',
	'/emailagreeyn',
	'/emailagreeresult',
	//
	'/panchok/orders',
];
/**
 * 레이아웃 관련 처리만 전담 하는 Router AfterHook
 * @param to
 * @param from
 */
const afterHookLayout = to => {
	//console.log('afterHookLayout ::', to, getHeaderType(to));
	store.dispatch('setLayout', {
		headerType: getHeaderType(to),
		footerType: getFooterType(to),
		// headerTitle,
		// topBanner,
		quick: isShownQuickMenu(to),
	});
};

const getHeaderType = to => {
	for (const [type, includePaths, excludePaths] of HEADER_TYPE_PAGES) {
		//console.log('getHeaderType ::', to, HEADER_TYPE_PAGES, type, includePaths, excludePaths);
		if (excludePaths?.some(path => wildcard(path, to.path))) continue;
		if (includePaths?.some(path => wildcard(path, to.path))) {
			//console.log('heeader Type::', type);
			return type;
		}
	}
	return 'None';
};

const getFooterType = to => {
	for (const [type, includePaths, excludePaths] of FOOTER_TYPE_PAGES) {
		if (excludePaths?.some(path => wildcard(path, to.path))) continue;
		if (includePaths?.some(path => wildcard(path, to.path))) {
			// console.log('footer Type::', type);
			return type;
		}
	}
	return 'None';
};
const isShownQuickMenu = to => QUICK_MENU_ENABLED_PAGES?.some(path => wildcard(path, to.path));

export default afterHookLayout;
